import script from "./PbxSiteFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxSiteFormModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxSiteFormModal.vue?vue&type=style&index=0&id=4253ef3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4253ef3e"]])

export default __exports__